export enum PusherEvents {
  NewUserMessage = 'NewUserMessage',
  NewAdminMessage = 'NewAdminMessage',
  NewChannelCreated = 'NewChannelCreated',
  ValidationRequested = 'ValidationRequested',
  TechValidationConfirmed = 'TechValidationConfirmed',
  TechTyping = 'TechTyping',
}
